import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AccessHistory } from "src/model/class/general classes/access-history";
import { AccessResult } from "src/components/shared-components/enum/enumAccessControl";
import { AccessHistoryService } from "src/service/access-history.service";

@Component({
    selector: "app-history-access-state-icon",
    templateUrl: "./history-access-state-icon.component.html",
    styleUrls: ["./history-access-state-icon.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HistoryAccessStateIconComponent implements OnInit {
  public cssComponentClassAccessResult: string = "";
  public iconName: string = "";

  @Input() historyAccess: AccessHistory;

  constructor(private _accessHistoryService: AccessHistoryService) { }

  ngOnInit() {
    this.getComponentColorClassByAccessResult();
    this.getComponentIconClassByAccessResult();
  }

  /**
   * Get css class to color component icon by reservation state
   */
  private getComponentColorClassByAccessResult(): void {
    switch (this.historyAccess.result) {
      case AccessResult.ACCESS_ALLOWED:
        this.cssComponentClassAccessResult = "allowed";
        break;
      default:
        this.cssComponentClassAccessResult = "denied";
        break;
    }
  }

  /**
   * Get icon name by access result
   */
  private getComponentIconClassByAccessResult(): void {
    this.iconName = this._accessHistoryService.getIconByAccessResult(
      this.historyAccess.result
    );
  }
}
